import wixWindow from 'wix-window';
import { BI_EVENTS } from 'public/biConsts';
import { sendBi, storeOriginForBI } from 'public/biModule';
import { session } from 'wix-storage';

$w.onReady(function () {
    const isMobile = wixWindow.formFactor === 'Mobile'
    if (!isMobile) {
        setVrColorChangeInteraction();
    }
    setBiBehavior();
});

const setVrColorChangeInteraction = () => {
    const colorDefinitions = {
        grey: { buttonId: 'greyButton', imageId: 'greyVr', strokeId: 'greyStroke' },
        blue: { buttonId: 'blueButton', imageId: 'blueVr', strokeId: 'blueStroke' },
        cyan: { buttonId: 'cyanButton', imageId: 'cyanVr', strokeId: 'cyanStroke' },
    };

    for (const color in colorDefinitions) {
        const { buttonId, imageId, strokeId } = colorDefinitions[color];
        $w(`#${buttonId}`).onClick(() => {
            $w('#greyStroke,#blueStroke,#cyanStroke').hide();
            $w('#greyVr,#blueVr,#cyanVr').hide();

            $w(`#${imageId}`).show();
            $w(`#${strokeId}`).show();
        });
    }
};

const setBiBehavior = () => {
    const biClickBindingEvents = [{
            buttonID: 'startProjectTop',
            origin: 'develop_smarter_deliver_faster_start_project',
            link_type: 'site_selector',
        },
        {
            buttonID: 'startProjectBottom',
            origin: 'start_project_today',
            link_type: 'site_selector',
        },
        {
            buttonID: 'exploreVelo',
            origin: 'one_platform_explore_velo',
            link_type: 'site_selector',
        },
        {
            buttonID: 'getStarted1',
            origin: 'visual_editor_get_started',
            link_type: 'site_selector',
        },
        {
            buttonID: 'getStarted2',
            origin: 'integrate_with_tools_get_started',
            link_type: 'site_selector',
        },
        {
            buttonID: 'getStarted3',
            origin: 'business_apps_get_started',
            link_type: 'site_selector',
        },
        {
            buttonID: 'getStarted4',
            origin: 'dynamic_content_get_started',
            link_type: 'site_selector',
        },
        {
            buttonID: 'getStarted5',
            origin: 'dev_cycle_tools_get_started',
            link_type: 'site_selector',
        },
        {
            buttonID: 'viewShowcase1',
            link_type: 'velo_project',
            category: 'showcase',
        },
        {
            buttonID: 'veloOnYoutube',
            link_type: 'youtube',
            category: 'tutorials',
        },
        {
            buttonID: 'exploreBlog',
            link_type: 'blog',
            category: 'blog'
        },
        {
            buttonID: 'getVeloCertified',
            category: 'articles',
            link_type: 'related_article',
        },
        {
            buttonID: 'earnRevenue',
            category: 'articles',
            link_type: 'related_article',
        },
    ];

    biClickBindingEvents.forEach((event) => {
        const { buttonID, origin, link_type, category } = event;

        $w(`#${buttonID}`).onClick(() => {
            sendBi(
                BI_EVENTS.ITEM_CLICKED,
                Object.assign({
                    page_name: 'home_page',
                    origin,
                    category,
                    link_type: link_type,
                    referral_url: wixWindow.referrer ?
                        wixWindow.referrer : session.getItem('previousPageURL'),
                    related_link: $w(`#${buttonID}`).link,
                })
            );
        });
    });

    $w('#viewShowcase2 , #viewShowcase3, #exploreMore, #visitForum').onClick(event => {
        const origin = 'main_content'

        const buttonID = event.target.id
        const url = $w(`#${buttonID}`).link
        
        setTimeout(() => {
            storeOriginForBI({ origin, url })
        }, 10)
    })
}